import { Component } from '@angular/core';
import { PagetoolbarComponent } from '../pagetoolbar/pagetoolbar.component';
import { NewsitemCardComponent } from '../newsitem/newsitem-card/newsitem-card.component';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { NewsitemService } from '../../services/newsitem.service';
import { NewsItem } from '../../interfaces/newsitem';
import { NewsitemAddComponent } from './newsitem-add/newsitem-add.component';
import { NewsitemEditComponent } from './newsitem-edit/newsitem-edit.component';
import { Observable } from 'rxjs';
import { Permission } from '../../interfaces/permission';
import { AuthService } from '../../auth/auth.service';
@Component({
    selector: 'app-newsitems',
    imports: [PagetoolbarComponent, NewsitemCardComponent, MatIconModule, CommonModule],
    templateUrl: './newsitems.component.html',
    styleUrl: './newsitems.component.scss'
})
export class NewsitemsComponent {
  newsitems: NewsItem[] = [];
  canAddNewsItem$: Observable<boolean>;

  constructor(
    private readonly dialog: MatDialog,
    private newsItemService: NewsitemService,
    private readonly authService: AuthService
  ) {
    this.canAddNewsItem$ = this.authService.hasPermissions$(Permission.NEWSITEM_EDIT);
  }

  ngOnInit(): void {
    this.getAllNewsItems();
  }

  getAllNewsItems(): void {
    this.newsItemService.getAllNewsItems$().subscribe({
      next: (data) => {
        this.newsitems = data;
      },
      error: (error) => {
        console.log(error);
      }
    });
  }
  addNewsItem() {
    const dialogRef = this.dialog.open(NewsitemAddComponent);

    dialogRef.componentInstance.responseSubjectNewNewsItem.subscribe((response: NewsItem) => {
      console.log('Received response:', response);
      this.newsitems.unshift(response);
    });
  }

  // This method will be called when an item is deleted
  removeNewsItem(deletedNewsItem: NewsItem) {
    this.newsitems = this.newsitems.filter((item) => item.id !== deletedNewsItem.id);
  }
}
